import { render } from "./BlogWisdomToothExtraction.vue?vue&type=template&id=31e3748c"
import script from "./BlogWisdomToothExtraction.vue?vue&type=script&lang=js"
export * from "./BlogWisdomToothExtraction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__